// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ngI2K","label":"styles_label__1LBLe"};